import React, { Component } from 'react';
import { BrowserRouter as Router, Route } from "react-router-dom";
import { AnimatedSwitch } from 'react-router-transition';
import { ParallaxProvider } from 'react-scroll-parallax';
import NotFound from './pages/NotFound';
import Home from './pages/Home';
import Navbar from './general/Navbar';
import Footer from './general/Footer';
import IconShopLanding from './pages/Shop/IosIcon/Landing'
import IconShopAppList from './pages/Shop/IosIcon/AppList'
import './App.css';

class App extends Component {
  render() {
    return (
      <Router>
        <ParallaxProvider>
          <div>
            <AnimatedSwitch
              atEnter={{ opacity: 0 }}
              atLeave={{ opacity: 0 }}
              atActive={{ opacity: 1 }}
              className="route-wrapper">
              <Route exact path="/" component={Home} />
              <Route exact path="/shop/icons" component={IconShopLanding} />
              <Route exact path="/shop/icons/List" component={IconShopAppList} />
              <Route component={NotFound} />
            </AnimatedSwitch>
          </div>
        </ParallaxProvider>
      </Router>
    )
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js